@use "@fukuri-admins/ui/layout" as *;

.root {
  position: relative;
  width: 100%;
  & i {
    position: absolute;
    color: #bdbdbd;
    font-size: 20px;
    top: 17px;
    right: 15px;
  }
}
.container {
  cursor: pointer;
  background: #ffffff;
  border: 1px solid $Border;
  border-radius: 4px;
  box-shadow: none;
  color: $Text;
  font-family: "Noto Sans JP"; //20230111
  font-size: 15px;
  font-weight: 400;
  height: auto;
  line-height: 1.4;
  padding: 15px 10px 15px 10px;
  width: 100%;
  max-width: 100%;
  &:focus-visible {
    outline: none;
  }
  &:focus {
    outline: none;
  }
}
